import { createObserverManager, getObservers } from "@/libs/observerHelper";

// Registry of observers
const observerRegistry = {
  connStateHandler: createObserverManager(),
  onStateChange: createObserverManager(),
  manualProfileUpdated: createObserverManager(),
  cleaningProfileUpdated: createObserverManager(),
  onDeviceFailure: createObserverManager(),
  onRecoveryStatusUpdated: createObserverManager(),
  onAutoProfileUpdated: createObserverManager(),
  onCycleTimesUpdated: createObserverManager(),
  onManualControlStatusUpdated: createObserverManager(),
  onDiafiltrationStatusUpdated: createObserverManager(),
  onVolumeThresholdError: createObserverManager(),
  onLicenseExpired: createObserverManager(),
  onDelayProfilePreparation: createObserverManager(),
  onDelayProfileStart: createObserverManager(),
  onDeviceLockUpdated: createObserverManager(),
};

const deviceHubObserver = {
  add: getObservers(observerRegistry, "add"),
  remove: getObservers(observerRegistry, "remove"),
  removeAll: getObservers(observerRegistry, "clear"),
  notify: getObservers(observerRegistry, "notify"),
};

export default deviceHubObserver;
